import { render, staticRenderFns } from "./list-news.vue?vue&type=template&id=021307b2&"
import script from "./list-news.vue?vue&type=script&lang=js&"
export * from "./list-news.vue?vue&type=script&lang=js&"
import style0 from "./list-news.vue?vue&type=style&index=0&id=021307b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports